module.exports = __webpack_public_path__ + "img/4.32750653.png";